/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_cat_intro = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Convert between ${i?.category} units instantly. Enter a value, choose your units, and the result updates as you type.`)
};

const es_uc_cat_intro = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Convierte entre unidades de ${i?.category} al instante. Ingresa un valor, elige tus unidades y el resultado se actualiza mientras escribes.`)
};

const de_uc_cat_intro = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rechnen Sie ${i?.category}-Einheiten sofort um. Geben Sie einen Wert ein, wählen Sie Ihre Einheiten, und das Ergebnis aktualisiert sich beim Tippen.`)
};

const nl_uc_cat_intro = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Converteer direct tussen ${i?.category} eenheden. Voer een waarde in, kies uw eenheden en het resultaat wordt bijgewerkt terwijl u typt.`)
};

const fr_uc_cat_intro = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Convertissez entre les unités ${i?.category} instantanément. Entrez une valeur, choisissez vos unités, et le résultat se met à jour au fur et à mesure que vous tapez.`)
};

const it_uc_cat_intro = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Converti istantaneamente tra unità di ${i?.category}. Immetti un valore, scegli le tue unità e il risultato si aggiorna mentre digiti.`)
};

const pt_br2_uc_cat_intro = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Converta entre unidades de ${i?.category} instantaneamente. Digite um valor, escolha suas unidades e o resultado é atualizado conforme você digita.`)
};

const pt_uc_cat_intro = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Converter entre unidades de ${i?.category} instantaneamente. Introduza um valor, escolha as suas unidades e o resultado actualiza à medida que digita.`)
};

const ja_uc_cat_intro = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.category}単位をすぐに変換します。値を入力し、単位を選択すると、結果がリアルタイムで更新されます。`)
};

const zh_uc_cat_intro = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ category: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_cat_intro = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_cat_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_cat_intro", locale)
	if (locale === "en") return en_uc_cat_intro(inputs)
	if (locale === "es") return es_uc_cat_intro(inputs)
	if (locale === "de") return de_uc_cat_intro(inputs)
	if (locale === "nl") return nl_uc_cat_intro(inputs)
	if (locale === "fr") return fr_uc_cat_intro(inputs)
	if (locale === "it") return it_uc_cat_intro(inputs)
	if (locale === "pt-BR") return pt_br2_uc_cat_intro(inputs)
	if (locale === "pt") return pt_uc_cat_intro(inputs)
	if (locale === "ja") return ja_uc_cat_intro(inputs)
	return zh_uc_cat_intro(inputs)
};